import React, { Suspense } from "react";
import { Input } from "reactstrap";

const PlacesAutocomplete = React.lazy(() =>
  import("../../components/common/PlacesAutocomplete")
);

const Fallback = ({ id, placeholder }) => (
  <Input
    type="text"
    className="lp2-loc-control"
    id={id}
    placeholder={placeholder}
  />
);

/**
 * Uber-style connected location group: a filled container with a pick-up row
 * (dot marker) and a drop-off row (square marker) joined by a vertical line.
 * Reuses the shared (lazy-loaded) PlacesAutocomplete component.
 */
const AddressFields = ({
  onCollection,
  onDelivery,
  highlight,
  initialCollectionAddress = "",
  initialDeliveryAddress = "",
}) => {
  return (
    <div className={"lp2-locations" + (highlight ? " is-highlight" : "")}>
      <div className="lp2-loc-row">
        <span className="lp2-loc-marker lp2-loc-dot" aria-hidden="true" />
        <div className="lp2-loc-input">
          <Suspense
            fallback={
              <Fallback id="lp2-collection" placeholder="Enter pick-up location" />
            }
          >
            <PlacesAutocomplete
              type="text"
              className="lp2-loc-control"
              id="lp2-collection"
              aria-label="Pick up address"
              placeholder="Enter pick-up location"
              initialValue={initialCollectionAddress}
              required
              onPlaceSelected={(place) => {
                onCollection({
                  lat: place?.geometry?.location?.lat(),
                  lng: place?.geometry?.location?.lng(),
                  address: place?.formatted_address || "",
                });
              }}
            />
          </Suspense>
        </div>
      </div>

      <div className="lp2-loc-row">
        <span className="lp2-loc-marker lp2-loc-square" aria-hidden="true" />
        <div className="lp2-loc-input">
          <Suspense
            fallback={
              <Fallback id="lp2-delivery" placeholder="Enter destination" />
            }
          >
            <PlacesAutocomplete
              type="text"
              className="lp2-loc-control"
              id="lp2-delivery"
              aria-label="Drop off address"
              placeholder="Enter destination"
              initialValue={initialDeliveryAddress}
              required
              onPlaceSelected={(place) => {
                onDelivery({
                  lat: place?.geometry?.location?.lat(),
                  lng: place?.geometry?.location?.lng(),
                  address: place?.formatted_address || "",
                });
              }}
            />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default AddressFields;
